import React, { useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import { downloadDatabaseBackupAdmin } from "../services/adminDatabaseBackupService";

const AdminDatabaseBackup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const downloadBackup = async () => {
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const response = await downloadDatabaseBackupAdmin();
      const contentDisposition = response.headers["content-disposition"];
      let filename = "database_backup.sql";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) filename = match[1];
      }
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setSuccess(`Backup downloaded: ${filename}`);
    } catch (err) {
      setError(err.response ? `Backup failed (status ${err.response.status})` : "Failed to download database backup");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminPageLayout
      title="Database Backup"
      subtitle="Download a full SQL backup of the production database."
      instruction="This generates a complete snapshot of the database. Use this before any major data migration or deployment. The backup file is in .sql format and can be restored using standard MySQL/PostgreSQL tools. Only perform this during low-traffic hours."
    >
      <div style={{ maxWidth: 520, background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "28px 24px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
            🗄️
          </div>
          <div>
            <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "1rem" }}>Full Database Export</div>
            <div style={{ fontSize: "0.82rem", color: "#64748b" }}>Includes all tables and records</div>
          </div>
        </div>

        {error && (
          <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px 14px", borderRadius: 8, fontSize: "0.85rem", marginBottom: 16 }}>
            ⚠️ {error}
          </div>
        )}
        {success && (
          <div style={{ background: "#dcfce7", color: "#15803d", padding: "10px 14px", borderRadius: 8, fontSize: "0.85rem", marginBottom: 16 }}>
            ✅ {success}
          </div>
        )}

        <button
          className="adm-btn adm-btn-primary"
          style={{ width: "100%", justifyContent: "center", padding: "12px" }}
          onClick={downloadBackup}
          disabled={loading}
        >
          {loading ? "⏳ Generating Backup…" : "⬇️ Download Database Backup"}
        </button>
      </div>
    </AdminPageLayout>
  );
};

export default AdminDatabaseBackup;
